import { createDateRange } from 'owa-datetime-utils';
import { loadFWH } from 'places-explore-operations';
import { updateCurrentDate } from 'places-user-session-stores';
import { orchestrator } from 'satcheljs';

orchestrator(updateCurrentDate, ({ date }) => {
    loadFWH(createDateRange(date, 1));
});
